import all from './all';
import search from './search';
import store from './store';
import bulkStore from './bulkStore';
import update from './update';
import destroy from './destroy';

export default {
  all,
  store,
  bulkStore,
  destroy,
  search,
  update,
};



// WEBPACK FOOTER //
// ./src/app/services/billProduct/index.js